import Layout from '@layout/Index'

export const orderImageRecaptureDetection = [
  {
    path: '/order-image-recapture-detection',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'summary-customer-table',
        component: () => import(/* webpackChunkName: "order-image-recapture-detection-summary-table" */ './pages/OrderImageRecaptureDetectionSummaryTable.vue'),
        meta: {
          title: '翻拍统计',
        }
      },
      {
        path: 'summary-project-table',
        component: () => import(/* webpackChunkName: "order-image-recapture-detection-project-summary-table" */ './pages/OrderImageRecaptureDetectionSummaryProjectTable.vue'),
        meta: {
          title: '翻拍统计',
        }
      },
      {
        path: 'summary-batch-table',
        component: () => import(/* webpackChunkName: "order-image-recapture-detection-batch-summary-table" */ './pages/OrderImageRecaptureDetectionSummaryBatchTable.vue'),
        meta: {
          title: '翻拍统计',
        }
      },
      {
        path: 'image-table',
        component: () => import(/* webpackChunkName: "order-image-recapture-detection-table" */ './pages/OrderImageRecaptureDetectionImageTable.vue'),
        meta: {
          title: '翻拍图片列表',
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/views/order-image-recapture-detection/order-image-recapture-detection.route.js